import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

import app from './modules/app'
import menu from './modules/menu'
import initiative from './modules/initiative'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    menu,
    initiative
  },
  state: {
    userImageSrc: '',
    clientLogoSrc: '',
    assessmentCompleted: false,
    currentInitiativeName: '',
    currentInitiativeTeamName: '',
    currentInitiativeTeamLead: '',
    currentUserName: '',
    activeInitiative: false,
    statusBar: 'The diagnostic will be automatically submitted on Oct. 19th, 2017'
  },
  mutations: {
    setUserImageSrc (state, val) {
      state.userImageSrc = val
    },
    setClientLogoSrc (state, val) {
      state.clientLogoSrc = val
    },
    setAssessmentCompleted (state, val) {
      state.assessmentCompleted = val
    },
    setCurrentInitiativeName (state, val) {
      state.currentInitiativeName = val
    },
    setCurrentInitiativeTeamName (state, val) {
      state.currentInitiativeTeamName = val
    },
    setCurrentInitiativeTeamLead (state, val) {
      state.currentInitiativeTeamLead = val
    },
    setCurrentUserName (state, val) {
      state.currentUserName = val
    },
    activeInitiativeMethod (state) {
      state.activeInitiative = true
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js